module.exports = __webpack_public_path__ + "static/maxima-telecom-results-403c23b5a53482463284a2706734c8aa.png";